"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const transactions_1 = require("companion-app-components/flux/transactions");
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const TagsField_1 = __importDefault(require("components/QuickenControls/TagsField"));
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const searchFilter_1 = require("data/transactions/searchFilter");
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const TagField = ({ attributes, forceStatic, callbacks, SHOW_ALL, fieldActive, txn, field, enableAutoFocus, showSplitWindow, staticValue, wrapClass, editClass, hoverClass, wrapText, tagsAsHashes, focusField, }) => {
    const { classes, theme } = useStyles();
    const renderTags = () => {
        var _a;
        const tagStatic = (0, searchFilter_1.makeTagsString)(txn.tags, tagsAsHashes);
        const isSplit = transactions_1.transactionsUtils.isSplitTxn(txn);
        let tagFrag;
        if (!showSplitWindow && fieldActive && !isSplit) {
            tagFrag = (<TagsField_1.default 
            // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'
            disableUnderline={(_a = theme.mixins) === null || _a === void 0 ? void 0 : _a.register.noUnderline} value={txn.tags} onChange={(e) => { var _a; return (_a = callbacks.handleChange) === null || _a === void 0 ? void 0 : _a.call(callbacks, e, 'tags'); }} fieldId="tags" autoFocus={enableAutoFocus} inputRef={(input) => {
                    focusField.current = input; // eslint-disable-line
                }}/>);
        }
        else if (isSplit || showSplitWindow) {
            tagFrag =
                <QTypography_1.default clickable thinFont className={classes.regItemCore}>
        </QTypography_1.default>;
        }
        else {
            tagFrag =
                // @ts-expect-error: missing props
                <QTip_1.default wrapOnly title={wrapText ? null : tagStatic} wrapId={`${txn.id}-${field}`}>
          <QTypography_1.default clickable={!forceStatic ? 'true' : null} thinFont className={classes.regItemCore}>
            {tagStatic || staticValue}
          </QTypography_1.default>
        </QTip_1.default>;
        }
        return tagFrag;
    };
    return (<styles_1.RegListItem {...attributes} className={(0, classnames_1.default)(classes.regItem, 'flex2', fieldActive ? 'wraptext' : wrapClass, editClass, hoverClass)}>
      {SHOW_ALL && renderTags()}
    </styles_1.RegListItem>);
};
exports.default = TagField;
